import React, { useState, useRef } from "react";
import "./profilecard.css";
import ClearIcon from "@material-ui/icons/Clear";
import axios from "axios";
import API_ENDPOINT from "../wm.api.service";
import { Link } from "react-router-dom";
import Cookies from "universal-cookie";
import { decode } from "base-64";
import { connect } from "react-redux";
import { compactNumber } from "../functions/general";
import { getFollowFollowingList } from "../functions/apis";
import { Container, Row, Col } from "react-bootstrap";
import pintrest from "../assets/images/pintrest.svg";
import linkedin from "../assets/images/linkedin.svg";
import facebook from "../assets/images/facebook.svg";
import twitter from "../assets/images/twitter.svg";
import youtube from "../assets/images/youtube.svg";
import insta from "../assets/images/insta.svg";
import dribble from "../assets/images/dribble.svg";
import behance from "../assets/images/behance.svg";
import WmModals from "../modals/Wm.Modals";
import Followlistcomponent from "./Follow.list.component";
import PhotoCameraIcon from "@material-ui/icons/PhotoCamera";
import { setMasterData, userProfileLoaded, userProfilePic, setUser } from "../services/actions/actions";
import FollowSkeleton from "../Components/skeletons/FollowSkeleton";
const cookies = new Cookies();
function Profilecard({ rootData, userProfilePics, setUsers }) {
  var token = cookies.get("wmtoken");
  if (cookies.get("wmusers")) {
    var user = decode(cookies.get("wmusers"));
  } else {
    var user = 'members';
  }
  const [followerModal, showFollowerModal] = useState(false);
  const [followingModal, showFollowingModal] = useState(false);
  const profile = useRef(null);
  const fileUpload = () => {
    profile.current.click();
  };
  const [isFollowListLoading, setIsFollowListLoading] = useState(false);
  const [isFollowerListLoading, setIsFollowerListLoading] = useState(false);
  const [followList, setFollowList] = useState([]);
  const [followingList, setFollowingList] = useState([]);
  const uploadPic = (e) => {
    userProfilePics(e);
    uploadPhoto();
  };
  const getFollowList = (action) => {
    setIsFollowListLoading(true)
    setIsFollowerListLoading(true)
    if (token) {
      getFollowFollowingList(action)
        .then(function (res) {
          if (action === "FOLLOWER") {
            setFollowList(res);
            setIsFollowListLoading(false)
          }
          if (action === "FOLLOWING") {
            setFollowingList(res);
            setIsFollowerListLoading(false)
          }
        })
        .catch(function (err) {
          console.log(err)
          setIsFollowListLoading(false)
          setIsFollowerListLoading(false)
        })
    }
  };
  const uploadPhoto = () => {
    var fd = new FormData();
    if (token) {
      fd.append("token", decode(token));
      fd.append("identity", "wmhandler");
      fd.append("photoType", "profile");
      fd.append("profile", rootData.uploadProfilePicFile);
      axios({
        method: "POST",
        url: `${API_ENDPOINT.apiURL}Profile/updateUserPhoto`,
        data: fd,
      })
        .then(function (response) {
          getWhoIsUser();
        })
        .catch(function (err) {
          console.log(err);
        });
    }
  };
  const [isOpenProfile, setIsOpenProfile] = useState(false);
  const openProfile = () => {
    setIsOpenProfile(true);
  };
  const getWhoIsUser = () => {
    var token = cookies.get("wmtoken");
    var fd = new FormData();
    {
      token && fd.append("token", decode(token));
    }
    fd.append("identity", "wmhandler");
    axios({
      method: "POST",
      url: `${API_ENDPOINT.apiURL}Authentication/fetchUserData`,
      data: fd,
    })
      .then(function (response) {
        setUsers(response.data[0]);
      })
      .catch(function (err) {
        console.log(err);
      });
  };

  function isValidURL(string) {
    var res = string.match(/(http(s)?:\/\/.)/g);
    return (res !== null)
  };

  return (
    <React.Fragment>
      <>
        <div className="profilecard h-full w-96 text-white px-3" id="profile_image">
          <>
            <div className="grid grid-cols-6 gap-3 pt-4 text-white">
              <div className="col-span-2 w-24 h-24 rounded-full transform -translate-y-12 z-40 relative border border-gray-200 bg-gray-100 cursor-pointer">
                <img onClick={() => openProfile()} src={rootData?.userProfilePic} alt="profile image" className="w-full h-full object-cover rounded-full"/>
                <input type="file" style={{ display: "none" }} ref={profile} onChange={(e) => uploadPic(e)} accept="image/png, image/jpeg, image/jpg"/>
                <div className="cursor-pointer edit_profile absolute w-8 h-8 transform translate-x-4" onClick={fileUpload}>
                  <PhotoCameraIcon className="cameraIcon" />
                </div>
              </div>
              <div className="col-span-4 ml-3">
                <span className="block dm-serif-text">{rootData.user.username && `@${rootData.user.username}`}</span>
                {user === 'members' && <span className="block manpro">{rootData.userData.profile_data?.fname} {rootData.userData.profile_data?.lname}</span>}
              </div>
            </div>
            <Container fluid className="px-0">
              <Row>
                <Col md={3}>
                  <div>
                    <div className="profile_stats flex flex-col items-center cursor-pointer select-none wm-flex-33" onClick={() => {showFollowerModal(true);getFollowList("FOLLOWER");}}>
                      <strong className="text-2xl manpro">
                        {rootData.userData?.follower_count? compactNumber(rootData.userData?.follower_count): 0}
                      </strong>
                      <small className="text-sm manpro">
                        {rootData.userData?.follower_count > 1 ? "Followers" : "Follower"}
                      </small>
                    </div>
                  </div>
                </Col>
                <Col md={3}>
                  <div>
                    <div className="profile_stats flex flex-col items-center cursor-pointer select-none wm-flex-33" onClick={() => {showFollowingModal(true);getFollowList("FOLLOWING");}}>
                      <strong className="text-2xl manpro">
                        {rootData.userData?.following_count ? compactNumber(rootData.userData?.following_count): 0}
                      </strong>
                      <small className="text-sm manpro">Following</small>
                    </div>
                  </div>
                </Col>
                <Col md={3}>
                  <div>
                    <Link to="/posts" className="block no-underline text-white wm-flex-33 flex-col items-center cursor-pointer">
                      <div className="profile_stats flex flex-col items-center cursor-pointer select-none wm-flex-33">
                        <strong className="text-2xl manpro">
                          {rootData?.postCount && compactNumber(JSON.parse(rootData?.postCount))}
                        </strong>
                        <small className="text-sm manpro">
                          {rootData?.postCount > 1 ? "Posts" : "Post"}
                        </small>
                      </div>
                    </Link>
                  </div>
                </Col>
                <Col md={3}>
                  <div>
                    <div className="block no-underline text-white wm-flex-33 flex-col items-center">
                      <div className="profile_stats flex flex-col items-center select-none wm-flex-33">
                        <strong className="text-2xl manpro">
                          {rootData?.postCount &&
                            compactNumber(+rootData.userData.profile_data.points)}
                        </strong>
                        <small className="text-sm manpro">
                          {+rootData.userData.profile_data.points > 0 ? "Points" : "Point"}
                        </small>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
            <div className="scrollable_part">
              <div className="profile_social_icon_wrapper flex space-x-5 mt-12 items-center pl-3 justify-center">
                {rootData.fb && (
                  <a href={`${isValidURL(rootData.fb) ? rootData.fb : `https://www.facebook.com/${rootData.fb.replace(/[/|&;$%@"<>()+,]/g, '')}`}`} target="_blank">
                    <img src={facebook} alt="icons" className="w-2.5" />
                  </a>
                )}
                {rootData.linkdin && (
                  <a href={`${isValidURL(rootData.linkdin) ? rootData.linkdin : `https://www.linkedin.com/in/${rootData.linkdin.replace(/[/|&;$%@"<>()+,]/g, '')}`}`} target="_blank">
                    <img src={linkedin} alt="icons" className="w-5" />
                  </a>
                )}
                {rootData.insta && (
                  <a href={`${isValidURL(rootData.insta) ? rootData.insta : `https://www.instagram.com/${rootData.insta.replace(/[/|&;$%@"<>()+,]/g, '')}`}`} target="_blank">
                    <img src={insta} alt="icons" className="w-5" />
                  </a>
                )}
                {rootData.youtube && (
                  <a href={`${isValidURL(rootData.youtube) ? rootData.youtube : `https://www.youtube.com/c/${rootData.youtube.replace(/[/|&;$%@"<>()+,]/g, '')}`}`} target="_blank">
                    <img src={youtube} alt="icons" className="w-5" />
                  </a>
                )}
                {rootData.behance && (
                  <a href={`${isValidURL(rootData.behance) ? rootData.behance : `https://www.behance.net/${rootData.behance.replace(/[/|&;$%@"<>()+,]/g, '')}`}`} target="_blank">
                    <img src={behance} alt="icons" className="w-5" />
                  </a>
                )}
                {rootData.pintrest && (
                  <a href={`${isValidURL(rootData.pintrest) ? rootData.pintrest : `https://in.pinterest.com/${rootData.pintrest.replace(/[/|&;$%@"<>()+,]/g, '')}`}`} target="_blank">
                    <img src={pintrest} alt="icons" className="w-5" />
                  </a>
                )}
                {rootData.dribble && (
                  <a href={`${isValidURL(rootData.dribble) ? rootData.dribble : `https://dribbble.com/${rootData.dribble.replace(/[/|&;$%@"<>()+,]/g, '')}`}`} target="_blank">
                    <img src={dribble} alt="icons" className="w-5" />
                  </a>
                )}
                {rootData.twitter && (
                  <a href={`${isValidURL(rootData.twitter) ? rootData.twitter : `https://twitter.com/${rootData.twitter.replace(/[/|&;$%@"<>()+,]/g, '')}`}`} target="_blank">
                    <img src={twitter} alt="icons" className="w-5" />
                  </a>
                )}
              </div>
            </div>
          </>
          <WmModals show={followerModal} onHide={() => showFollowerModal(false)} size="lg" className="edu-modal">
            <h4 className="manpro font-semibold text-2xl">
              {rootData.userData?.follower_count > 1 ? "Followers" : "Follower"}
            </h4>
            <ClearIcon className="cancel absolute cursor-pointer" onClick={() => showFollowerModal(false)} />
            {isFollowListLoading ? <FollowSkeleton />
              : followList.length <= 0 ? (
                <div className="text-center">
                  <span className="manpro font-semibold">No Followers Found</span>
                </div>
              ) : (
                followList.map((followList, idx) => {
                  return (
                    <Followlistcomponent key={idx} followData={followList} hideModal={() => showFollowerModal(false)} view="FOLLOWERS" />
                  );
                })
              )}
          </WmModals>
          <WmModals show={followingModal} onHide={() => showFollowingModal(false)} size="lg" className="edu-modal">
            <h4 className="manpro font-semibold text-2xl">Following</h4>
            <ClearIcon className="cancel absolute cursor-pointer" onClick={() => showFollowingModal(false)} />
            {isFollowerListLoading ? <FollowSkeleton /> : followingList.length <= 0 ? (
              <div className="text-center">
                <span className="manpro font-semibold">
                  No Followings Found
                </span>
              </div>
            ) : (
              followingList.map((followingList, idx) => {
                return (
                  <Followlistcomponent key={idx} followData={followingList} hideModal={() => showFollowerModal(false)} view="FOLLOWING"/>
                );
              })
            )}
          </WmModals>
          <WmModals show={isOpenProfile} onHide={() => setIsOpenProfile(false)} size="sm" className="">
            <div className="bannerModal p-2 relative">
              <div className="clearIcon absolute right-3 top-3 rounded-full w-8 h-8 flex items-center justify-center bg-gray-200 cursor-pointer" onClick={() => setIsOpenProfile(false)}>
                <ClearIcon />
              </div>
              <img src={rootData.userProfilePic} alt="banner" className="w-100"/>
            </div>
          </WmModals>
        </div>
      </>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToState = (dispatch) => {
  return {
    setData: (value) => {
      dispatch(setMasterData(value));
    },
    userProfileLoadeds: (value) => {
      dispatch(userProfileLoaded(value));
    },
    userProfilePics: (value) => {
      dispatch(userProfilePic(value));
    },
    setUsers: (value) => {
      dispatch(setUser(value));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToState)(Profilecard);
